import { gql } from '@apollo/client'

export const EDIT_VACCINATION = gql`
  mutation EditVaccination($inputData: EditVaccinationInput!) {
    editVaccination(inputData: $inputData) {
      id
    }
  }
`
